import { Container, Typography } from '@mui/material';
import React from 'react';
import { Helmet } from 'react-helmet';

const Unauthorized = () => {
    return (
        <>
            <Helmet>
                <title>Unauthorized Access | sitepilot.online</title>
                <meta
                    name="description"
                    content="You do not have permission to access this page. Please contact your administrator for access."
                />
                <meta
                    name="keywords"
                    content="unauthorized, access denied, restricted access, admin access, permission error, sitepilot"
                />
            </Helmet>

            <Container component="main" maxWidth="xl">
                <Typography variant="h5" align="center" marginBottom={2}>
                    Unauthorized
                </Typography>

                <Typography variant="h6" align="center" color="textSecondary">
                    Welcome to the onboarding.sitepilot.online
                </Typography>
            </Container>
        </>
    );
};

export default Unauthorized;